import AMapLoader from '@amap/amap-jsapi-loader'

export const amapConfig = {
  key: process.env.VUE_APP_AMAP_KEY || '',
  securityJsCode: process.env.VUE_APP_AMAP_SECURITY_JS_CODE || ''
}

export function setAmapSecurityConfig() {
  const code = amapConfig.securityJsCode
  if (!code) throw new Error('请配置本地地图 Key')
  window._AMapSecurityConfig = { securityJsCode: code }
}

export function loadAmapSDK(plugins = []) {
  const key = amapConfig.key
  if (!key) return Promise.reject(new Error('请配置本地地图 Key'))
  setAmapSecurityConfig()
  return AMapLoader.load({ key, version: '2.0', plugins })
}
